import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control/index'

const DraftDeletedModal = (props) => {
  const { enableModal, onClose } = props

  return (
    <Modal isOpen={enableModal} size='medium'>
      <ModalHeader title="Your draft can't be saved." onClose={onClose} />
      <ModalBody>
        Seems like this draft has been deleted by someone, so it can't be saved.
      </ModalBody>
      <ModalFooter>
        <ButtonControl
          title='Go back to homepage'
          variant='primary'
          onClick={() => { window.location.assign(window.location.origin + '/moderation/overview') }}
        />
      </ModalFooter>
    </Modal>
  )
}

export default DraftDeletedModal
